<div class="services">
  @for (workflow of workflows | values; track workflow) {
  <fieldset class="workflow">
    <legend class="block-header">{{ workflow.label }}</legend>
    <div class="block-content">
      <div class="col-sm-12 one-row">
        @for (service of services[workflow.id]; track service) { @if
        (isVisible(service.id)) {
        <div class="row">
          <label class="col-sm-4 control-label">{{ service.name }}</label>
          <div class="col-sm-8 field-wrap">
            @if (service.variations.length > 0) {
            <div>
              <select
                [ngModel]="findSelectedVariation(service)"
                (ngModelChange)="enableServiceVariation(service, $event.id)"
                class="form-select lg"
              >
                @for (variation of toNormalizedVariations(service); track
                variation) {
                <option [ngValue]="variation">
                  {{ variation.description }}
                </option>
                }
              </select>
            </div>
            } @if (service.variations.length === 0) {
            <div>
              <label class="col-sm-8">
                <input
                  [ngModel]="service.enabled"
                  (ngModelChange)="toggleService(service)"
                  type="checkbox"
                />
                <span>{{ service.description }}</span>
              </label>
            </div>
            }
          </div>
        </div>
        } }
      </div>
    </div>
  </fieldset>
  }
</div>
